import { createRouter, createWebHistory } from 'vue-router';
const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: '/',
            name: 'chat',
            component: () => import('@/views/wapchat/index.vue'),
        },
    ],
});
export default router;
